import React from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { Button } from '@cokitchen/cokitchen-components';
import { Link, useLocation } from 'react-router-dom';

import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';

import { Tab } from 'components/tab';
import useRoleContext from 'contexts/role.context';
import { InventoryModule } from 'models/permission.model';
import { SUBMIT_PERMISSION_ACTIONS } from 'utils/authorization';

import List from './list';
import {
  buildTransferRoute,
  getTransferStoreTypeFromPathname,
  normalizeTransferStoreType,
  TRANSFER_STORE_TYPE_OPTIONS
} from '../store-type';

export type DateRangeType = {
  startDate: Date;
  endDate: Date;
};

const TransferList = () => {
  const { can } = useRoleContext();
  const location = useLocation();
  const storeType = normalizeTransferStoreType(getTransferStoreTypeFromPathname(location.pathname));
  const transferStoreLabel = TRANSFER_STORE_TYPE_OPTIONS[storeType].name;
  const newTransferPath = buildTransferRoute(storeType, MAIN_STORE_ROUTE_KEYS.NEW_PROCUREMENT);
  const transferModule =
    storeType === 'KITCHEN_STORE'
      ? InventoryModule.KitchenStoreTransfer
      : InventoryModule.MainStoreTransfer;
  const canCreateTransfer = can(transferModule, SUBMIT_PERMISSION_ACTIONS);
  const tables = [
    {
      label: 'Sent requests',
      key: 'sent-requests',
      content: <List storeType={storeType} direction={'to'} />
    },
    {
      label: 'Received requests',
      key: 'received-requests',
      content: <List storeType={storeType} direction={'from'} />
    }
  ];

  return (
    <div>
      <PageHeaderText
        title={`New Transfer (${transferStoreLabel})`}
        description={`Manage transfer requests for ${transferStoreLabel.toLowerCase()}.`}>
        {canCreateTransfer && (
          <Link to={newTransferPath}>
            <Button variant='block' color='primary' className='px-6 py-2 text-sm'>
              New Transfer
            </Button>
          </Link>
        )}
      </PageHeaderText>

      <div className='mb-7'>
        <Tab tabs={tables} defaultSelectedTab={tables[0]} />
      </div>
    </div>
  );
};

export default TransferList;
